import { Spin } from 'antd';
import {CenteredContent} from 'components/container';

export default ()=><CenteredContent full><Spin size="large"/></CenteredContent>;